import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { DatePipe } from "@angular/common";
import { SupportService } from "../services/support-service";

@Component({
  selector: "app-vacation-history",
  templateUrl: "./vacation-history.component.html",
  styleUrls: ["./vacation-history.component.scss"],
})
export class VacationHistoryComponent implements OnInit {
  techApprovedList: any;
  showError = false;
  constructor(
    private appservice: AppService,
    private datepipe: DatePipe,
    private supportService: SupportService
  ) {
    this.techApprovedList = [];
    this.techApprovedList = [];
  }
  search: any = "";
  filtercopy: any = [];
  ngOnInit() {
    this.getallapprovedvacation();
    if (localStorage.getItem("testCenterName") != null) {
      this.supportService.testCenterName.next(
        localStorage.getItem("testCenterName")
      );
    }

    if (localStorage.getItem("stateName") != null) {
      this.supportService.stateName.next(localStorage.getItem("stateName"));
    }
  }
  getallapprovedvacation() {
    const data = {
      technicianId: "",
    };
    this.appservice.getallapprovedvacation(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.techApprovedList = [];
            this.filtercopy = [];
            for (let index = 0; index < res["entity"].length; index++) {
              res["entity"][index].fullName =
                res["entity"][index].firstName +
                " " +
                res["entity"][index].lastName;
              this.techApprovedList.push(res["entity"][index]);
              this.filtercopy.push(this.techApprovedList[index]);
            }
            this.showError = false;
          } else {
            this.techApprovedList = [];
            this.showError = true;
          }
        } else {
          this.techApprovedList = [];
          this.showError = true;
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  filterItem(value) {
    if (!value) {
      this.getallapprovedvacation();
    } else {
      this.techApprovedList = Object.assign([], this.filtercopy).filter(
        (item) => item.fullName.toLowerCase().indexOf(value.toLowerCase()) > -1
      );

      if (this.techApprovedList.length === 0) {
        this.clearFilter();
      }
    }
  }

  clearFilter() {
    this.techApprovedList = [];
    this.showError = true;
  }

  getOpacityValue(i) {
    if (i !== 0) {
      return 0;
    }
    return 1;
  }

  transformDate(date): string {
    if (date) {
      return this.datepipe.transform(date, "MMM d, y"); // 2018-11-23
    }
    return "";
  }

  calculatelefthours(list, index, totalHours) {
    let hours = 0;
    if (list && list.length > 0) {
      for (let i = list.length - 1; i >= 0; i--) {
        hours = hours + list[i].totalHours;
        if (i === index) {
          break;
        }
      }
    }
    return totalHours - hours;
  }
}
